var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useQueryClient, useMutation } from 'react-query';
import { CacheKeys } from '../constants';
import { useChuckClientContext } from './useChuckClientContext';
import { useAPI } from './useAPI';
export const useMatchUpdate = () => {
    const queryClient = useQueryClient();
    const { patch } = useAPI();
    const { client } = useChuckClientContext();
    return useMutation((_a) => __awaiter(void 0, void 0, void 0, function* () {
        var { id } = _a, update = __rest(_a, ["id"]);
        switch (update.type) {
            case 'review':
                return patch({
                    url: `/matches/${id}`,
                    data: { review: update.review, rating: update.rating }
                }).then((r) => r.data);
            case 'flag':
                return patch({
                    url: `/matches/${id}`,
                    data: { flag: update.flag }
                }).then((r) => r.data);
        }
    }), {
        onSuccess: (data) => {
            queryClient.setQueryData([CacheKeys.MATCHES], (prev) => {
                if (!prev)
                    return undefined;
                return Object.assign(Object.assign({}, prev), { pages: prev.pages.map((page) => {
                        return Object.assign(Object.assign({}, page), { records: page.records.map((match) => match.id === data.id ? data : match) });
                    }) });
            });
            queryClient.setQueryData([CacheKeys.MATCH, data.id], () => data);
        },
        onError: (err) => {
            client.captureException(err);
        }
    });
};
//# sourceMappingURL=useMatchUpdate.js.map